module.exports = __webpack_public_path__ + "static/media/search.8e540e98.svg";